module.exports = __webpack_public_path__ + "img/5-5.27e7248d.png";